import { render, staticRenderFns } from "./turnover_report.vue?vue&type=template&id=01caf710&scoped=true"
import script from "./turnover_report.vue?vue&type=script&lang=js"
export * from "./turnover_report.vue?vue&type=script&lang=js"
import style0 from "./turnover_report.vue?vue&type=style&index=0&id=01caf710&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01caf710",
  null
  
)

export default component.exports